module.exports = __webpack_public_path__ + "media/images/icons/country_flags/is-8f88619495adccb68a6dc200787f6df0.svg";